import { AUFMASS_STATUS } from "../../../../constants/aufmass-status";
import INVOICE_STATUS from "../../../../constants/invoice-status";
import SUPPLIER_INFO_STATUS from "../../../../constants/supplier-info-status";

/** Invoice statuses where aufmass can be opened or created */
export const AUFMASS_NAVIGABLE_INVOICE_STATUSES = [
	INVOICE_STATUS.DRAFT,
	INVOICE_STATUS.FINALIZED,
];

export const canNavigateToAufmass = (data) =>
	!!data && AUFMASS_NAVIGABLE_INVOICE_STATUSES.includes(data.status);

export const canDeleteInvoice = (data) =>
	!!data &&
	data.status !== INVOICE_STATUS.FINALIZED &&
	!(
		data.hasSupplierInfo &&
		data.supplierInfoStatus === SUPPLIER_INFO_STATUS.FINALIZED
	);

export const getInvoiceWorkflowState = (data) => {
	if (!data) return "pending";

	if (
		data.status === INVOICE_STATUS.REJECTED ||
		data.status === INVOICE_STATUS.ARCHIVED
	) {
		return "pending";
	}

	if (
		data.status === INVOICE_STATUS.FINALIZED ||
		data.hasAufmass ||
		data.hasSupplierInfo
	) {
		return "done";
	}

	if (data.status === INVOICE_STATUS.DRAFT) {
		return "progress";
	}

	return "done";
};

export const getAufmassWorkflowState = (data) => {
	if (
		data?.hasSupplierInfo &&
		data.supplierInfoStatus === SUPPLIER_INFO_STATUS.DRAFT
	) {
		return "done";
	}
	if (!data?.hasAufmass) return "pending";
	if (data.aufmassStatus === AUFMASS_STATUS.FINALIZED) return "done";
	if (data.aufmassStatus === AUFMASS_STATUS.DRAFT) return "progress";
	return "done";
};

export const getSupplierInfoWorkflowState = (data) => {
	if (!data?.hasSupplierInfo) return "pending";
	if (data.supplierInfoStatus === SUPPLIER_INFO_STATUS.FINALIZED) {
		return "done";
	}
	if (data.supplierInfoStatus === SUPPLIER_INFO_STATUS.DRAFT) {
		return "progress";
	}
	return "pending";
};
